import { Button, Collapse, Form, Typography } from 'antd';
import React, { useEffect, useMemo, useState } from 'react'
import LilyButton from '../../../../../components/button/lily-button';
import UploadFile from '../../../../../components/upload/upload-file';
import { useClaimContext } from '../../component/claim-context';
import ReceiptExample from '../../../../../assets/receipt-example.png';

const PharmacyReceipt = (props) => {
    const { caseType, setCurrentType, } = props;
    const { Title, Text } = Typography;
    const [isUploading, setIsUploading] = useState(false);
    const [isNext, setIsNext] = useState(false);

    const { setClaimForm, claimForm, setSupportOptions } = useClaimContext();

    const handleSubmit = () => {
        setSupportOptions((prev) =>
            prev.map((item) =>
                item.value === caseType ? { ...item, checked: noInform } : item
            )
        );
        setCurrentType('')
    }

    const noInform = useMemo(() => claimForm?.proofOfPayment.length !== 0, [claimForm]);

    return (
        <div className='d-flex flex-column gap-4'>
            <Title className='mb-1 main-title' level={3}>
                Original Pharmacy Receipt
            </Title>
            <Text>
                The original pharmacy receipt received from your pharmacy with your Rx which must include the following information:
                <ul>
                    <li>Patient name and address</li>
                    <li>Pharmacy name, address, and phone number</li>
                    <li>Doctor or healthcare provider name, address, and phone number</li>
                    <li>Prescription # (Rx#), fill date, drug name, strength, NDC #, and quantity</li>
                    <li>Overall prescription price and copay amount/out of pocket expense paid</li>
                </ul>
            </Text>
            <UploadFile fieldKey="proofOfPayment" uploadedFiles={claimForm.proofOfPayment} setClaimForm={setClaimForm} setIsUploading={setIsUploading} setIsNext={setIsNext} />
            <Collapse
                style={{ backgroundColor: 'white' }}
                collapsible="header"
                items={[
                    {
                        key: '1',
                        label: 'View Original Pharmacy Receipt Example',
                        children: (<div className='d-flex align-items-center justify-content-center'>
                            <img width='300px' src={ReceiptExample} alt='Receipt Example' />
                        </div>)
                    },
                ]}
            />
            <div className='d-flex flex-row justify-content-end mt-5'>
                <Button
                    color="default"
                    variant="link"
                    onClick={handleSubmit}
                    disabled={isUploading}
                    style={{ width: '200px' }}
                >
                    Back
                </Button>
                <LilyButton style={{ width: '200px' }} disabled={!noInform || isUploading || !isNext} onClick={handleSubmit} text="Next" />
            </div>
        </div>
    )
}

export default PharmacyReceipt